import React from 'react';
import ILink from '../../../types/ILink';
import { ConfidentialLevel } from '../../../types/api/ConfidentialLevel';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { isNonEmptyArray } from '../../../lib/typeGuards';
import { ConfidentialLevelMetaInfo } from './partials/ConfidentialLevelMetaInfo';
import { ValidUntilMetaInfo } from './partials/ValidUntilMetaInfo';
import { CreateDateMetaInfo } from './partials/CreateDateMetaInfo';
import { EditDateMetaInfo } from './partials/EditDateMetaInfo';
import { KeywordsMetaInfo } from './partials/KeywordsMetaInfo';
import { PublicationDateMetaInfo } from './partials/PublicationDateMetaInfo';
import TextBubble from '../TextBubble/TextBubble';
import { EditorialResponsibleMetaInfo } from './partials/EditorialResponsibleMetaInfo';
import IUrl, { ISonURL } from '../../../types/IUrl';
import { ProfileImageSmall } from '../../../types/api/ImageType';

export type EditorialResponsibleProps = {
  profileLink: ISonURL;
  profileName: string;
  profileImageUrl: ProfileImageSmall;
  personInfoCardUrl: IUrl;
};

type PageMetaInfoProps = {
  changeComment?: string;
  editDate?: string;
  editedBy?: ILink;
  createdBy?: ILink;
  createDate?: string;
  publishedBy?: ILink;
  publicationDate?: string;
  validUntil?: string;
  validityExpired?: boolean;
  keywords?: ILink[];
  confidentialLevel?: ConfidentialLevel;
  editorialResponsible?: EditorialResponsibleProps;
};

export function MetaInfoPage({
  changeComment,
  publishedBy,
  publicationDate,
  editDate,
  editedBy,
  createDate,
  createdBy,
  keywords,
  validUntil,
  validityExpired,
  confidentialLevel,
  editorialResponsible,
}: PageMetaInfoProps) {
  const { t } = useSonTranslation('MetaInfo');

  const hasContent =
    changeComment ||
    publishedBy ||
    publicationDate ||
    editDate ||
    createdBy ||
    (keywords && isNonEmptyArray(keywords)) ||
    validUntil ||
    confidentialLevel ||
    editorialResponsible;

  if (!hasContent) {
    return null;
  }

  return (
    <div className="meta-info">
      <dl className="meta-info__definition-list font-regular-15-19">
        {editorialResponsible && <EditorialResponsibleMetaInfo editorialResponsible={editorialResponsible} />}
        {confidentialLevel && <ConfidentialLevelMetaInfo confidentialLevel={confidentialLevel} />}
        {validUntil && <ValidUntilMetaInfo validUntil={validUntil} validityExpired={validityExpired} />}
        {createDate && <CreateDateMetaInfo createdDate={createDate} createdBy={createdBy} />}
        {editDate && <EditDateMetaInfo editDate={editDate} editedBy={editedBy} />}
        {keywords && isNonEmptyArray(keywords) && <KeywordsMetaInfo keywords={keywords} term={t('keywordsOfPage')} />}
        {publicationDate && <PublicationDateMetaInfo publicationDate={publicationDate} publishedBy={publishedBy} />}
      </dl>
      {changeComment && <TextBubble type={t('changeComment')} content={changeComment} />}
    </div>
  );
}
